
import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";

export async function loginApi({ email, password }) {
  try {
    const response = await api.post(
      apiPath.authLogin,
      { email, password },
      { headers: { "Content-Type": "application/json" } }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Login failed" };
  }
}

export async function googleLoginApi(idToken) {
  try{
        console.log("Sending ID Token:", idToken);

    const response = await api.post(
      apiPath.googleLogin,{
        idToken,
      },
      {
        headers: {
          "Content-Type":"application/json",
        },
      }
    );
    console.log("Axios Response:", response);
    console.log("Axios Response Data:", response.data);
    return response.data;
  }catch (error) {
    console.log("Axios Error:", error);
    console.log("Error Response:", error.response);
    console.log("Error Data:", error.response?.data);
    throw error.response?.data || {
      message: "Google Login Failed"
    };
  }
  
}
export async function verifyOtpApi(email, otp) {
  try {
    const response = await api.post(
      apiPath.verifyOtp,
      {
        email,
        otp,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || {
      message: "OTP Verification Failed",
    };
  }
}

export async function resendOtpApi(email) {
  try {
    const response = await api.post(
      apiPath.resendOtp,
      {
        email,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Failed to resend OTP",
      }
    );
  }
}